// // Version 2.0 -- rewrote to implement ControlValueAssesor

// //****** write this control so that a hardcoded set of values can be passed in OR a codeset table code can be passed in  ******

// // Return simple value (CODE) or complex value (CODE,DESC)?   Later may be better if description is needed outside of control.

import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    forwardRef,
    Input,
    OnChanges,
    OnDestroy,
    Output,
    SimpleChanges
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CodeSetDataService } from '@Core/services/proprietary/codeset-data.service';

//Rename to CodeItem???
export class DropdownValue {
    Code: string;
    Code_Desc: string;
    Icon: string;
    Tooltip: string;

    constructor(code: string, code_desc: string, icon: string = null) {
        this.Code = code;
        this.Code_Desc = code_desc;
        this.Icon = icon;
    }
}

@Component({
    standalone: false,
    selector: 'ep-dropdown',
    template: `
    <div class="unity-form-row">
      <select
        [disabled]="controlDisabled"
        [style.width]="getWidth()"
        [(ngModel)]="selectedOption"
        (ngModelChange)="selectChanged($event)"
        (focus)="onFocus()"
        (blur)="onBlur()"
      >
        <option *ngIf="nullValue" [value]="nullValue.Code" [ngbTooltip]="nullValue.Tooltip">
          {{ getNullValueDesc() }}
        </option>
        <ng-container *ngIf="!hideEmpty">
          <option *ngFor="let v of codeValues; trackBy: trackByKey" [value]="v.Code">
            {{ getDisplayValue(v.Code, v.Code_Desc) }}
          </option>
        </ng-container>

        <!--Usage of the hideEmpty option should be rare. Needed for things like hiding the Empty code 
        within the State codeset in places where State shouldn't be clearable.-->
        <ng-container *ngIf="hideEmpty">
          <ng-container *ngFor="let v of codeValues; trackBy: trackByKey">
            <option *ngIf="v.Code && v.Code.trim() != ''" [value]="v.Code">
              {{ getDisplayValue(v.Code, v.Code_Desc) }}
            </option>
          </ng-container>
        </ng-container>
        <option *ngIf="valueMissingFromCodes" [value]="selectedOption">{{ selectedOption }}</option>
      </select>
      <aurora-icon icon="chevron-down"></aurora-icon>
    </div>
  `,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DropdownComponent),
            multi: true
        }
    ]
})
export class DropdownComponent implements ControlValueAccessor, OnChanges, OnDestroy {
    @Input()
    name: string = null;

    @Input()
    codeValues: DropdownValue[] = [];

    @Input('codeSet') codeSet: string = 'NONE';

    @Input('disabled')
    controlDisabled: boolean = false;

    @Input()
    nullValue: DropdownValue = null;

    @Input()
    hideEmpty: boolean = false;

    @Input()
    width: string = '100%';

    @Input() showCode: string = 'none';

    @Input('addOptionIfMissing')
    set addOptionIfMissing(value: boolean) {
        if (value === false) {
            //Only set to false if false is specifically passed in, otherwise the default value of true remains the value.
            this._addOptionIfMissing = false;
        }
    }

    get addOptionIfMissing(): boolean {
        return this._addOptionIfMissing;
    }

    private _addOptionIfMissing: boolean = true;

    @Output()
    blur = new EventEmitter();

    @Output()
    focus = new EventEmitter();

    @Output()
    dataSelected = new EventEmitter();

    errorMessage: any;
    _codeSet: string = 'NONE';

    codeSetSub: Subscription;

    public selectedOption: string = '';
    private innerValue: string = '';

    private _showCode: string = 'none';

    valueMissingFromCodes: boolean = false;

    constructor(private codeSetDataService: CodeSetDataService, private cdRef: ChangeDetectorRef) { }

    getWidth() {
        return this.width;
    }

    setShowCode(value: string) {
        if (value) {
            let test = value.toLowerCase();
            switch (test) {
                case 'y':
                    test = 'left';
                    console.warn("Legacy: showCode of 'Y' is obsolete.   Use 'left','right' or 'none'");
                    break;
                case 'n':
                    test = 'none';
                    console.warn("Legacy: showCode of 'N' is obsolete.   Use 'none'");
                    break;
                case 'left':
                case 'right':
                case 'none':
                    break;
                default:
                    console.error("Invalid showCode '" + value + "' provided. Use 'left','right' or 'none'");
            }
            this._showCode = test;
        }
    }

    getDisplayValue(code: string, desc: string) {
        if (code == null) {
            return desc;
        }
        switch (this._showCode) {
            case 'left':
                return code + '\xA0\xA0\xA0\xA0-\xA0\xA0\xA0\xA0' + desc;
            case 'right':
                return desc + ' (' + code + ')';
            default:
                return desc;
        }
    }

    getNullValueDesc() {
        if (this.nullValue) {
            if (this.nullValue.Code_Desc && this.nullValue.Code_Desc != '') {
                return '<' + this.nullValue.Code_Desc + '>';
            } else {
                return this.nullValue.Code_Desc || '';
            }
        }
    }

    setValueMissingFromCodes() {
        if (this.addOptionIfMissing && this.selectedOption && this.codeValues) {
            let index = this.codeValues.map((x) => x.Code).indexOf(this.selectedOption);

            if (index != -1) {
                this.valueMissingFromCodes = false;
            } else {
                if (this.nullValue && this.nullValue.Code == this.selectedOption) {
                    this.valueMissingFromCodes = false;
                } else {
                    this.valueMissingFromCodes = true;
                }
            }
        } else {
            this.valueMissingFromCodes = false;
        }
    }

    onFocus() {
        this.focus.emit();
    }

    onBlur() {
        this.blur.emit();
        this.onTouchedCallback();
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (changes.hasOwnProperty(propName)) {
                let change = changes[propName];
                switch (propName) {
                    case 'codeSet':
                        this._codeSet = change.currentValue;
                        if (
                            change.currentValue &&
                            change.currentValue.toUpperCase() != 'NONE' &&
                            change.currentValue.toUpperCase() != 'INSTALLPLAN'
                        ) {
                            this.getCodes(change.currentValue);
                        }
                        break;
                    case 'showCode':
                        if (change.currentValue) {
                            this.setShowCode(change.currentValue);
                        }
                        break;
                    case 'codeValues':
                        this.setValueMissingFromCodes();
                        break;
                }
            }
        }
    }

    ngOnDestroy() {
        this.valueMissingFromCodes = false;
        if (this.codeSetSub) {
            this.codeSetSub.unsubscribe();
        }
    }

    getCodes(codeSet: string) {
        this.codeSetSub = this.codeSetDataService.get(codeSet).subscribe(
            (values) => {
                this.codeValues = values;
                this.setValueMissingFromCodes();
                this.cdRef.detectChanges();
            },
            (error) => (this.errorMessage = <any>error)
        );
    }

    selectChanged(v: any) {
        let data: any = { Code: v, Code_Desc: null };
        let index = -1;

        if (this.codeValues) {
            index = this.codeValues.map((x) => x.Code).indexOf(v);
        }

        if (index != -1) {
            data = this.codeValues[index];
        } else {
            if (this.nullValue && this.nullValue.Code == v) {
                data = this.nullValue;
            }
        }
        this.setValueMissingFromCodes();
        this.value = data.Code;
        this.dataSelected.emit(data);
    }

    clear() {
        this.value = this.nullValue;
    }

    trackByKey(index: number, item: any) {
        return item.Code;
    }

    //***** BEGIN CONTROL VALUE ACCESSOR HANDLERS *****//

    //Placeholders for the callbacks which are later provided by the Control Value Accessor
    private onChangeCallback = (_: any) => { };
    private onTouchedCallback = () => { };

    //get accessor
    get value(): any {
        return this.innerValue;
    }

    set value(v: any) {
        if (v !== this.innerValue) {
            this.innerValue = v;
            this.selectedOption = v;
            this.onChangeCallback(v);
        }
    }

    //From ControlValueAccessor interface - Allows Angular to update the model
    writeValue(value: any): void {
        if (value !== undefined && value !== this.innerValue) {
            this.innerValue = value;
            this.selectedOption = value;
            this.setValueMissingFromCodes();
            this.cdRef.detectChanges();
        }
    }

    //From ControlValueAccessor interface - Allows Angular to register a function to call when the model changes.
    registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }

    //From ControlValueAccessor interface -  Allows Angular to register a function to call when the input has been touched.
    registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }

    //From ControlValueAccessor interface -  Allows Angular to disable the input.
    setDisabledState(isDisabled: boolean): void {
        this.controlDisabled = isDisabled;
    }

    //***** END CONTROL VALUE ACCESSOR HANDLERS *****//
}
